import React from 'react'
import Styles from "./Styles.module.scss";

export default function Page({ className, ...props} : React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  return (
    <div className={[Styles.paper, className].join(" ")}  {...props}/>
  )
}